import React, { useEffect, useRef, useState } from "react";
import { FolderPlus, Folder, Settings } from "lucide-react";
import { RootState, useAppDispatch } from "../../redux/store";
import { PolicyCategoriesSidebar, PolicyList } from "../../components";
import { useSelector } from "react-redux";
import { TimeoffCategoryType, TimeoffPolicy } from "../../types";
import { getAllTimeoffCategories, getAssignedTimeoffCategories } from "../../redux/features/common";
import { getTimeoffPolicyList } from "../../redux/features/timeoff";
import { useNavigate } from "react-router";
import { clearSelectedCategoryToEdit, setCategoryEditMode, setSelectedCategoryToEdit } from "../../redux/features/timeoffcategory";

const PolicyListing: React.FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { allTimeoffCategories: timeoffCategories, isLoadingAllCategories: isLoadingCategories } = useSelector((state: RootState) => state.common);
    const { timeoffPolicies, isLoadingTimeoffPolicies } = useSelector((state: RootState) => state.timeoff);
    const [selectedCategory, setSelectedCategory] = useState<TimeoffCategoryType | null>(null);
    const firstRender = useRef(true);

    // Fetch categories once
    useEffect(() => {
        dispatch(getAllTimeoffCategories());
    }, []);

    // Once categories load, set first category & fetch policies
    useEffect(() => {
        if (timeoffCategories.length > 0) {
            const defaultCategory = timeoffCategories[0];
            setSelectedCategory(defaultCategory);
            dispatch(getTimeoffPolicyList({ category_code: defaultCategory.category_code }));
        }
    }, [timeoffCategories]);

    useEffect(() => {
        // console.log("Selected Category:", selectedCategory);
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        if (selectedCategory) {
            dispatch(getTimeoffPolicyList({ category_code: selectedCategory.category_code }));
        }
    }, [selectedCategory]);

    const handleAddCategory = () => {
        dispatch(clearSelectedCategoryToEdit());
        dispatch(setCategoryEditMode(false));
        navigate("/create-timeoff-category");
    };

    const handleUpdateCategory = (category: TimeoffCategoryType) => {
        // select details to update
        dispatch(setSelectedCategoryToEdit(category));
        dispatch(setCategoryEditMode(true));
        navigate("/create-timeoff-category");
    };

    return (
        <div className="flex h-screen">
            <div className="overflow-y-auto max-h-screen"> {/* Added scrollable container */}
                <PolicyCategoriesSidebar
                    categories={timeoffCategories}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    isLoadingCategories={isLoadingCategories}
                    handleAddCategory={handleAddCategory}
                    handleUpdateCategory={handleUpdateCategory}
                />
            </div>
            <PolicyList categoryPolicies={timeoffPolicies} isLoadingPolicies={isLoadingTimeoffPolicies} />
        </div>
    );
};

export default PolicyListing;